module.exports = __webpack_public_path__ + "img/team-ux.007cbd9d.svg";